import { styleCardsBorders } from '@sections/jobs/card-borders';

if (document.querySelector('.location-select-js')) {
  // If params in the URL
  const params = (new URL(document.location)).searchParams;
  const paramsDepartment = params.get("department");
  const paramsLocation = params.get("location");

  const preselectJobLocation = document.querySelector('.location-select-js').dataset.loc
  const preselectJobDepartment = document.querySelector('.department-select-js').dataset.department

  $('.department-select-js').on('change', (e) => {
    const selectedOption = e.target.selectedOptions[0];
    const department = selectedOption.attributes.value.value;
    const cards = document.querySelectorAll('.jobs-list__card-wrapper');
    const locationSelectedValue = document.querySelector(".location-select-js").value;

    $(cards).removeClass('hidden');

    for (var i = 0; i < cards.length; ++i) {
      var item = cards[i];

      if (locationSelectedValue) {
        // If no job department, left part always returns false, so right part value "wins"
        // If I have a job department, I check that current item does not contains my selection
        // If it does not contain my selection (= true), I hide it
        // I use the same logic for location, if my item does not include my selection (true), I hide
        if ((department && !item.classList.contains(department)) || !item.innerText.includes(locationSelectedValue)) {
          item.classList.add('hidden');
        }
      } else if(department) {
        if((!item.classList.contains(department))) {
          item.classList.add('hidden');
        }
      }
    }
    noOpeningsMessage();
    styleCardsBorders();
  });

  $('.location-select-js').on('change', (e) => {
    var selectedOption = e.target.selectedOptions[0]
    var location = selectedOption.attributes.value.value
    var cards = document.querySelectorAll('.jobs-list__card-wrapper');
    var departmentSelectedValue = document.querySelector(".department-select-js").value;

    $(cards).removeClass('hidden')

    for (var i = 0; i < cards.length; ++i) {
      var item = cards[i];
      // First I check if I have a value in "department"
      // This way I know if I sort by location ONLY or not
      if (departmentSelectedValue) {
        if((!item.classList.contains(departmentSelectedValue) || !item.innerText.includes(location))) {
          item.classList.add('hidden');
        }
      } else if(location) {
        if((!item.innerText.includes(location))) {
          item.classList.add('hidden');
        }
      }
    }
    noOpeningsMessage();
    styleCardsBorders();
  });

  // Preselect location depending on Prismic select
  // If no Prismic preselect, depends on param location (if any)
  if(preselectJobLocation) {
    $('.location-select-js').val(preselectJobLocation).trigger('change');
  } else {
    $('.location-select-js').val(paramsLocation).trigger('change');
  }

  // Preselect department depending on Prismic select
  // If no Prismic preselect, depends on param department (if any)
  if(preselectJobDepartment) {
    $('.department-select-js').val(preselectJobDepartment).trigger('change');
  } else {
    $('.department-select-js').val(paramsDepartment).trigger('change');
  }

  // Style cards borders.
  styleCardsBorders();
}

function noOpeningsMessage() {
   // Check if all jobs are hidden
  $('.no-job-openings').empty();
  const jobCount =  document.querySelector('.jobs-list__wrapper').dataset.count
  const emptyMessage =  document.querySelector('.jobs-list__wrapper').dataset.empty
  if($('.jobs-list__card-wrapper.hidden').length === parseInt(jobCount)) {
    $('.no-job-openings').append(emptyMessage);
  }
}
